export var AuthServiceEnum;
(function (AuthServiceEnum) {
    AuthServiceEnum["LOGIN_REDIRECT"] = "loginRedirect";
    AuthServiceEnum["LOGIN_POPUP"] = "loginPopup";
    AuthServiceEnum["ACQUIRE_TOKEN_REDIRECT"] = "acquireTokenRedirect";
    AuthServiceEnum["ACQUIRE_TOKEN_POPUP"] = "acquireTokenPopup";
})(AuthServiceEnum || (AuthServiceEnum = {}));
export var LocalStorageEnum;
(function (LocalStorageEnum) {
    LocalStorageEnum["AUTH_EMAIL"] = "authEmail";
})(LocalStorageEnum || (LocalStorageEnum = {}));
